import React from "react"
import { AspectRatio as AspectRatioOg } from "@chakra-ui/react"

import type { PropsWithChildrenAndStyle } from "~components/shared/todo-lib-react-components/types"

interface Props extends PropsWithChildrenAndStyle {
    readonly ratio: number
}

export default function AspectRatio({ style, ratio, children }: Props) {
    return (
        <AspectRatioOg sx={style} ratio={ratio}>
            {children}
        </AspectRatioOg>
    )
}
